// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"title_scroll-black___fFhA","title":"title_title__rbiGS"};